import { createContext } from 'react';

export type InteracDetails = {
  RecipientPhoneNumber: string;
  RecipientName: string;
  RecipientEmailAddress: string;
  Question: string;
  Answer: string;
  ClientReferenceNumber?: string;
};

export type InteracInfoContextCtx = {
  isInteracQuestionsRequired?: boolean;
  addInteracEmail: boolean;
  interacDetails?: InteracDetails;
  updateInterac: (
    addInteracEmail: boolean,
    isInteracQuestionsRequired?: boolean,
    interacDetails?: InteracDetails,
  ) => void;
};

const InteracInfoContext = createContext<InteracInfoContextCtx>({
  isInteracQuestionsRequired: false,
  addInteracEmail: false,
  interacDetails: {
    RecipientPhoneNumber: '',
    RecipientName: '',
    RecipientEmailAddress: '',
    Question: '',
    Answer: '',
  },
  updateInterac: () => {},
});

export default InteracInfoContext;
